import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonCol, IonGrid, IonIcon, IonLabel, IonRow, IonToggle } from '@ionic/angular';
import { LetDirective } from '@ngrx/component';

import { AttachmentParentType, NtyUniversalCreateComponent } from '@ninety/mobile/platform/api';
import {
  AttachmentsComponent,
  DescriptionComponent,
  NtyDatePickerComponent,
  NtyFormErrorComponent,
  NtyFormOptionalComponent,
  NtyOptionComponent,
  NtySelectComponent,
  TeamMultiSelectComponent,
  TeamSingleSelectComponent,
  TitleComponent,
  UserSingleSelectComponent,
} from '@ninety/mobile/platform/components';

import { RockQuarter } from '../../_state/models/rock-request.model';

import { CreateRockStore } from './create-rock.store';

@Component({
  selector: 'nty-create-rock',
  imports: [
    IonCol,
    IonGrid,
    IonIcon,
    IonLabel,
    IonRow,
    IonToggle,
    CommonModule,
    LetDirective,
    FormsModule,
    ReactiveFormsModule,
    DescriptionComponent,
    TeamSingleSelectComponent,
    NtySelectComponent,
    NtyOptionComponent,
    TitleComponent,
    UserSingleSelectComponent,
    AttachmentsComponent,
    TeamMultiSelectComponent,
    NtyDatePickerComponent,
    NtyFormOptionalComponent,
    NtyFormErrorComponent,
  ],
  providers: [CreateRockStore],
  templateUrl: './create-rock.component.html',
  styleUrls: ['./create-rock.component.scss'],
})
export class CreateRockComponent implements OnInit, OnDestroy, NtyUniversalCreateComponent {
  readonly store = inject(CreateRockStore);

  readonly attachmentType = AttachmentParentType.Rock;

  @ViewChild('attachments') attachments?: AttachmentsComponent;

  RockQuarter = RockQuarter;

  ngOnInit(): void {
    this.store.init();
  }

  ngOnDestroy(): void {
    this.store.destroy();
  }

  create(): void {
    this.store.createRock(this.attachments);
  }

  protected isOptional(formControl: AbstractControl): boolean {
    return !formControl.hasValidator(Validators.required) && !formControl.disabled;
  }

  protected hasRequiredError(controlName: string): boolean {
    return this.store.form.get(controlName)?.hasError('required') || false;
  }
}
